<template>
  <div class="fleet-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewFleetLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal modern-modal--md">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p v-if="editMode" class="modern-modal__subtitle">
                Update the fleet group settings below, then choose Update to save your changes.
              </p>
              <p v-else class="modern-modal__subtitle">
                Complete the fleet group form to add a new group for your vehicles.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <form class="modal-form" @submit.prevent>
                <div class="modal-columns">
                  <div class="modal-column">
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Name<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          type="text"
                          v-model="name"
                          name="name"
                          class="vs-inputx vs-input--input normal" />
                      </div>
                      <span></span>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Code (Shortname)<sup>*</sup></label>
                      <div class="vs-con-input">
                        <input
                          type="text"
                          v-model="code"
                          name="code"
                          class="vs-inputx vs-input--input normal" />
                      </div>
                      <span></span>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Is Fuel Consumption<sup>*</sup></label>
                      <v-select
                        @input="(x) => (is_fuel_consumption = x.value)"
                        :clearable="false"
                        :value="getSelectValue(is_fuel_consumption, fuel_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="fuel_array" />
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Phone Numbers<sup>*</sup></label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            @input="validatePhoneNumber"
                            v-model="phone"
                            name="phone"
                            class="vs-inputx vs-input--input normal" />
                        </div>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="field-inline__action"
                          @click="pushPhone"
                          :disabled="this.phone == '' || this.phoneError !== null">
                          +
                        </vs-button>
                      </div>
                      <p v-if="phoneError" class="field-helper field-helper--error">
                        {{ phoneError }}
                      </p>
                      <div class="phone-pill-wrapper">
                        <div
                          class="phone-pill"
                          v-for="(item, index) in phone_array"
                          :key="index">
                          <vs-button
                            class="phone-pill__label"
                            color="primary"
                            type="border"
                            @click="updatePhone(index)">
                            {{ item }}
                          </vs-button>
                          <vs-button
                            class="phone-pill__remove"
                            color="danger"
                            @click="deletePhone(index)">
                            x
                          </vs-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-column">
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overspeed Threshold (km/h)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overspeed_switch"
                            v-model="overspeed"
                            name="overspeed"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overspeed_switch }" />
                        </div>
                        <vs-switch v-model="overspeed_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine ON Dry Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_on_switch"
                            v-model="overstay_engine_on"
                            name="overstay_engine_on"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_on_switch }" />
                        </div>
                        <vs-switch v-model="overstay_on_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine ON Fresh Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_engine_on_fresh_switch"
                            v-model="overstay_engine_on_fresh"
                            name="overstay_engine_on_fresh"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_engine_on_fresh_switch }" />
                        </div>
                        <vs-switch v-model="overstay_engine_on_fresh_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine OFF Dry Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_off_switch"
                            v-model="overstay_engine_off"
                            name="overstay_engine_off"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_off_switch }" />
                        </div>
                        <vs-switch v-model="overstay_off_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine OFF Fresh Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_engine_off_fresh_switch"
                            v-model="overstay_engine_off_fresh"
                            name="overstay_engine_off_fresh"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_engine_off_fresh_switch }" />
                        </div>
                        <vs-switch v-model="overstay_engine_off_fresh_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>

                    <!-- new, tronton -->
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine OFF Tronton Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_engine_off_tronton_switch"
                            v-model="overstay_engine_off_tronton"
                            name="overstay_engine_off_tronton"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_engine_off_tronton_switch }" />
                        </div>
                        <vs-switch v-model="overstay_engine_off_tronton_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>
                    <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Overstay Engine ON Tronton Threshold (minutes)</label>
                      <div class="field-inline">
                        <div class="vs-con-input field-inline__input">
                          <input
                            type="text"
                            :disabled="!overstay_engine_on_tronton_switch"
                            v-model="overstay_engine_on_tronton"
                            name="overstay_engine_on_tronton"
                            class="vs-inputx vs-input--input normal"
                            :class="{ 'is-disabled': !overstay_engine_on_tronton_switch }" />
                        </div>
                        <vs-switch v-model="overstay_engine_on_tronton_switch">
                          <span slot="on">On</span>
                          <span slot="off">Off</span>
                        </vs-switch>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
              @click="submitForm"
              v-if="!editMode"
              color="primary">
              Submit
            </vs-button>
            <vs-button
              class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
              @click="updateForm"
              v-if="editMode"
              color="primary">
              Update
            </vs-button>
            <vs-button
              color="primary"
              type="border"
              class="mb-2"
              @click="closeForm">
              Cancel
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import { over } from 'lodash';
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewFleet: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    dataLevel: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  created() {
    this.populateLevel()
    const user = localStorage.getItem('userData')
  },
  watch: {
    overspeed_switch(val) {
      if (val == false) {
        this.overspeed = 0;
      }
    },
    overstay_on_switch(val) {
      if (val == false) {
        this.overstay_engine_on = 0;
      }
    },
    overstay_off_switch(val) {
      if (val == false) {
        this.overstay_engine_off = 0;
      }
    },
    overstay_engine_on_fresh_switch(val) {
      if (val == false) {
        this.overstay_engine_on_fresh = 0;
      }
    },
    overstay_engine_off_fresh_switch(val) {
      if (val == false) {
        this.overstay_engine_off_fresh = 0;
      }
    },
    overstay_engine_off_tronton_switch(val) {
      if (val == false) {
        this.overstay_engine_off_tronton = 0;
      }
    },
    overstay_engine_on_tronton_switch(val) {
      if (val == false) {
        this.overstay_engine_on_tronton = 0;
      }
    },
    name(val) {
      this.name = val.toUpperCase()
    },
    code(val) {
      this.code = val.toUpperCase()
    },
    level(val) {
      if (parseInt(val) > 1) {
        this.calculateLevel(val)
      } else {
        this.parent = ''
        this.parent_array = []
      }
    },
    addNewFleetLocal(va) {
      if (this.addNewFleet && this.editMode) {
        this.name = this.dataEdit.fleet_group_name
        this.code = this.dataEdit.fleet_group_code
        this.is_fuel_consumption = this.dataEdit.is_fuel_consumption
        this.level = this.dataEdit.levels
        this.calculateLevel(this.dataEdit.levels)
        this.parent = this.dataEdit.parent_id
        this.overspeed = this.dataEdit.overspeed
        this.overstay_engine_on = this.dataEdit.overstay_engine_on
        this.overstay_engine_off = this.dataEdit.overstay_engine_off
        this.overstay_engine_on_fresh = this.dataEdit.overstay_engine_on_fresh
        this.overstay_engine_off_fresh = this.dataEdit.overstay_engine_off_fresh
        this.overstay_engine_off_tronton = this.dataEdit.overstay_engine_off_tronton
        this.overstay_engine_on_tronton = this.dataEdit.overstay_engine_on_tronton
        this.is_mutation = this.dataEdit.notif_mutation
        this.phone_array = JSON.parse(this.dataEdit.phones)
        this.overspeed_switch = this.overspeed == 0 ? false : true
        this.overstay_on_switch = this.overstay_engine_on == 0 ? false : true
        this.overstay_off_switch = this.overstay_engine_off == 0 ? false : true
        this.overstay_engine_on_fresh_switch = this.overstay_engine_on_fresh == 0 ? false : true
        this.overstay_engine_off_fresh_switch = this.overstay_engine_off_fresh == 0 ? false : true
        this.overstay_engine_off_tronton_switch = this.overstay_engine_off_tronton == 0 ? false : true
        this.overstay_engine_on_tronton_switch = this.overstay_engine_on_tronton == 0 ? false : true
      }
    },
    editMode(val) {
      if (val) {
        if (this.addNewFleet && this.editMode) {
          this.name = this.dataEdit.fleet_group_name
          this.code = this.dataEdit.fleet_group_code
          this.is_fuel_consumption = this.dataEdit.is_fuel_consumption
          this.level = this.dataEdit.levels
          this.calculateLevel(this.dataEdit.levels)
          this.parent = this.dataEdit.parent_id
          this.overspeed = this.dataEdit.overspeed
          this.overstay_engine_on = this.dataEdit.overstay_engine_on
          this.overstay_engine_off = this.dataEdit.overstay_engine_off
          this.overstay_engine_on_fresh = this.dataEdit.overstay_engine_on_fresh
          this.overstay_engine_off_fresh = this.dataEdit.overstay_engine_off_fresh
          this.overstay_engine_off_tronton = this.dataEdit.overstay_engine_off_tronton
          this.overstay_engine_on_tronton = this.dataEdit.overstay_engine_on_tronton
          if (this.dataEdit.phones != null && this.dataEdit.phones != 'null')
            this.phone_array = JSON.parse(this.dataEdit.phones)
          else this.phone_array = []
          this.overspeed_switch = this.overspeed == 0 ? false : true
          this.overstay_on_switch = this.overstay_engine_on == 0 ? false : true
          this.overstay_off_switch = this.overstay_engine_off == 0 ? false : true
          this.overstay_engine_on_fresh_switch = this.overstay_engine_on_fresh == 0 ? false : true
          this.overstay_engine_off_fresh_switch = this.overstay_engine_off_fresh == 0 ? false : true
          this.overstay_engine_off_tronton_switch = this.overstay_engine_off_tronton == 0 ? false : true
          this.overstay_engine_on_tronton_switch = this.overstay_engine_on_tronton == 0 ? false : true
        }
      } else {
        this.clearFields()
      }
    }
  },
  computed: {
    addNewFleetLocal: {
      get() {
        let isOpen = false
        if (typeof this.addNewFleet === 'string') {
          const normalized = this.addNewFleet.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.addNewFleet)
            } catch (e) {
              isOpen = !!this.addNewFleet
            }
          }
        } else {
          isOpen = !!this.addNewFleet
        }

        if (isOpen && !this.editMode) {
          this.clearFields()
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      level_array: [],
      parent_array: [],
      fuel_array: [
        { text: 'TRUE', value: 1 },
        { text: 'FALSE', value: 0 },
      ],
      phone_array: [],
      phoneError: null,
      phone: '',
      name: '',
      is_fuel_consumption: 1,
      is_mutation: 0,
      code: '',
      status: 1,
      parent: '',
      level: 1,
      overspeed: 0,
      overstay_engine_on: 0,
      overstay_engine_off: 0,
      overstay_engine_on_fresh: 0,
      overstay_engine_off_fresh: 0,
      overstay_engine_off_tronton: 0,
      overstay_engine_on_tronton: 0,
      overspeed_switch: true,
      overstay_on_switch: true,
      overstay_off_switch: true,
      overstay_engine_on_fresh_switch: true,
      overstay_engine_off_fresh_switch: true,
      overstay_engine_off_tronton_switch: true,
      overstay_engine_on_tronton_switch: true,
    }
  },
  methods: {
    validatePhoneNumber() {
      const phoneNumberRegex = /^(\+62|62|0)8[1-9]\d{7,10}$/

      if (!phoneNumberRegex.test(this.phone) && this.phone !== '') {
        this.phoneError = 'Invalid phone number format'
      } else {
        this.phoneError = null
      }
    },
    pushPhone() {
      if (this.phone !== '') {
        const spliceNum = this.phone.startsWith('0')
          ? 1
          : this.phone.startsWith('+62')
            ? 3
            : this.phone.startsWith('62')
              ? 2
              : 0
        this.phone = '+62' + this.phone.slice(spliceNum)

        this.phone_array.push(this.phone)
        this.phone = ''
      } else {
        this.$toast.error('Phone Number Cannot Be Empty')
      }
    },
    updatePhone(val) {
      if (this.phone !== '') {
        this.$toast.error('Phone Number Field Should Be Empty Before Updating')
      } else {
        this.phone = this.phone_array[val]
        this.phone_array.splice(val, 1)
        this.validatePhoneNumber()
      }
    },
    deletePhone(val) {
      //
      this.phone_array.splice(val, 1)
      //
    },
    populateLevel() {
      REPO.getListLevel()
        .then((res) => {
          const levels = res.data.data
          let tmp = []
          levels.forEach((x) => {
            tmp.push({
              text: x.description,
              value: x.id,
            })
          })
          this.level_array = tmp
        })
        .catch((err) => {
          //
          this.$toast.error(err.message)
        })
    },
    calculateLevel(val) {
      this.parent_array = []
      this.parent = ''
      this.allData.forEach((x) => {
        if (parseInt(x.levels) === parseInt(val) - 1) {
          this.parent_array.push({
            text: x.fleet_group_name,
            value: x.id,
          })
        }
      })

      if (this.parent_array.length > 0) {
        this.parent = this.parent_array[0].value
      } else {
        this.parent = ''
        this.parent_array = []
      }
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.name = ''
      this.code = ''
      this.level = 1
      this.is_fuel_consumption = 1
      this.parent = ''
      this.overspeed = 0
      this.overstay_engine_on = 0
      this.overstay_engine_off = 0
      this.overstay_engine_on_fresh = 0
      this.overstay_engine_off_fresh = 0
      this.overstay_engine_off_tronton = 0
      this.overstay_engine_on_tronton = 0
      this.phone_array = []
      this.phone = ''
      this.overspeed_switch = true
      this.overstay_on_switch = true
      this.overstay_off_switch = true
      this.overstay_engine_on_fresh_switch = true
      this.overstay_engine_off_fresh_switch = true
      this.overstay_engine_off_tronton_switch = true
      this.overstay_engine_on_tronton_switch = true
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        fleet_group_name: this.name,
        fleet_group_code: this.code,
        levels: this.level,
        is_fuel_consumption: this.is_fuel_consumption,
        overspeed: this.overspeed,
        overstay_engine_on: this.overstay_engine_on,
        overstay_engine_off: this.overstay_engine_off,
        overstay_engine_on_fresh: this.overstay_engine_on_fresh,
        overstay_engine_off_fresh: this.overstay_engine_off_fresh,
        overstay_engine_off_tronton: this.overstay_engine_off_tronton,
        overstay_engine_on_tronton: this.overstay_engine_on_tronton,
        notif_mutation: this.is_mutation,
        phones: JSON.stringify(this.phone_array),
        parent_id: this.parent,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postFleetGroup(dataForm)
        .then((res) => {
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteFleetGroup(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        fleet_group_name: this.name,
        is_fuel_consumption: this.is_fuel_consumption,
        fleet_group_code: this.code,
        levels: this.level,
        overspeed: this.overspeed,
        overstay_engine_on: this.overstay_engine_on,
        overstay_engine_off: this.overstay_engine_off,
        overstay_engine_on_fresh: this.overstay_engine_on_fresh,
        overstay_engine_off_fresh: this.overstay_engine_off_fresh,
        overstay_engine_off_tronton: this.overstay_engine_off_tronton,
        overstay_engine_on_tronton: this.overstay_engine_on_tronton,
        notif_mutation: this.is_mutation,
        phones: JSON.stringify(this.phone_array),
        parent_id: this.parent,
        updated_by: this.$dataLocal.UserData().name,
      }
      REPO.updateFleetGroup(dataForm, this.dataEdit.id)
        .then((res) => {
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>

<style>
sup {
  color: red;
}

.vs-tooltip {
  z-index: 999999;
}

#content-area.content-area-default .fleet-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .fleet-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .fleet-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .fleet-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .fleet-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.fleet-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(900px, 96vw);
  max-height: 84vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--md {
  width: min(900px, 94vw);
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 26px 32px 18px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #64748b;
  max-width: 520px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(84vh - 180px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-modal__scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 9999px;
}

.modern-modal__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 32px 28px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modal-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
}

.modal-column {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field-group--stacked {
  white-space: normal;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: 0.01em;
}

.field-group span {
  display: none;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-inputx.vs-input--input.normal {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.94rem;
  line-height: 1.5;
  color: #0f172a;
}

.field-group .vs-inputx.vs-input--input.normal:focus {
  box-shadow: none;
}

.field-group .vs-inputx.vs-input--input.normal.is-disabled {
  background: #f1f5f9;
  color: #94a3b8;
}

.field-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.field-inline__input {
  flex: 1;
}

.field-inline__action {
  min-width: 44px;
  height: 44px;
  padding: 0 !important;
  border-radius: 10px !important;
  font-size: 1.25rem;
  line-height: 1;
}

.field-helper {
  margin-top: 6px;
  font-size: 0.78rem;
}

.field-helper--error {
  color: #b91c1c;
}

.phone-pill-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.phone-pill {
  display: flex;
  align-items: center;
  border-radius: 9999px;
  overflow: hidden;
  background: #e2e8f0;
}

.phone-pill__label,
.phone-pill__remove {
  border-radius: 0 !important;
  min-height: 38px;
}

.phone-pill__label {
  padding: 0 16px;
}

.phone-pill__remove {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.field-group ::v-deep(.vs__dropdown-toggle) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  padding: 6px 14px;
  min-height: 44px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.field-group ::v-deep(.vs__dropdown-toggle:focus),
.field-group ::v-deep(.vs__dropdown-toggle.vs__dropdown-toggle--focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__selected-options) {
  flex-wrap: wrap;
  gap: 6px;
}

.field-group ::v-deep(.vs__dropdown-menu) {
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  margin-top: 6px;
}

.field-group ::v-deep(.vs__search) {
  padding: 0;
  margin: 0;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .modal-columns {
    grid-template-columns: 1fr;
  }

  .modern-modal {
    width: min(720px, 96vw);
  }
}

@media (max-width: 768px) {
  .modern-modal {
    width: min(680px, 96vw);
  }

  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 640px) {
  .modern-modal__header {
    flex-direction: column;
    align-items: stretch;
  }

  .modern-modal__close {
    align-self: flex-end;
  }

  .modern-modal {
    width: min(600px, 94vw);
  }
}
</style>
